export const DAMAGE_PALLETS_IMAGES_NUMBER_LIMIT = 10;
